import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { NavBar } from '../components/NavBar';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import teamImg from '../assets/040.jpg';

export default function ImprintPage() {
  const { t } = useTranslation();

  return (
    <div className="App">
      <SEOHead
        pageTitleOverride={`${t('imprint.title')} | Legend Spa Hotel`}
        descriptionOverride="Legal information and project management of Legend Spa Hotel C.A (Compañía Anónima) — Anke Dittrich & Volker Suski."
      />
      <NavBar />
      <div className="legal-page" data-testid="imprint-page">
        <div className="legal-hero">
          <div className="container">
            <h1>{t('imprint.title')}</h1>
            <p>{t('imprint.company')}</p>
          </div>
        </div>

        <div className="container">
          <Link to="/" className="legal-back-btn" data-testid="imprint-back-btn">
            <ArrowLeft size={16} /> Back to Home
          </Link>

          <div className="legal-content">
            <h2>{t('imprint.managers')}</h2>
            <p>The Legend Spa Hotel project is managed and developed by a dedicated team of wellness, architecture, and investment professionals committed to creating the most extraordinary longevity destination in the Caribbean.</p>

            {/* Team Photo */}
            <div style={{ margin: '32px 0', borderRadius: '16px', overflow: 'hidden', border: '1px solid var(--color-border)', maxWidth: '700px' }}>
              <img
                src={teamImg}
                alt="Anke Dittrich, Volker Suski & Heli - Legend Spa Hotel Team"
                style={{ width: '100%', display: 'block', objectFit: 'cover' }}
                data-testid="imprint-team-photo"
              />
              <div style={{ padding: '16px 20px', background: 'var(--color-surface)', borderTop: '1px solid var(--color-border)' }}>
                <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', textAlign: 'center', fontStyle: 'italic' }}>
                  Anke Dittrich, Volker Suski & Heli &mdash; Isla Margarita, Venezuela
                </p>
              </div>
            </div>

            <div className="imprint-team">
              <div className="team-card" data-testid="team-card-anke">
                <div className="team-card-avatar">A</div>
                <h4>Anke Dittrich</h4>
                <p>Project Manager &amp; Co-Founder<br />Legend Spa Hotel C.A (Compañía Anónima)</p>
              </div>
              <div className="team-card" data-testid="team-card-volker">
                <div className="team-card-avatar">V</div>
                <h4>Volker Suski</h4>
                <p>Project Manager &amp; Co-Founder<br />Legend Spa Hotel C.A (Compañía Anónima)</p>
              </div>
            </div>

            <h2>Company Information</h2>
            <p><strong style={{ color: 'var(--color-gold)' }}>Company:</strong> Legend Spa Hotel C.A (Compañía Anónima)</p>
            <p><strong style={{ color: 'var(--color-gold)' }}>Project:</strong> Legend Wellness Spa &amp; Hotel</p>
            <p><strong style={{ color: 'var(--color-gold)' }}>Location:</strong> Isla Margarita, Municipio Arismendi, Venezuela</p>
            <p><strong style={{ color: 'var(--color-gold)' }}>Established:</strong> Est. 2026</p>
            <p>
              <strong style={{ color: 'var(--color-gold)' }}>Email:</strong>{' '}
              <a href="mailto:info@legend-spa.me">info@legend-spa.me</a>
            </p>
            <p>
              <strong style={{ color: 'var(--color-gold)' }}>Website:</strong>{' '}
              <a href="https://legend-spa.me" target="_blank" rel="noopener noreferrer">legend-spa.me</a>
            </p>

            <h2>{t('imprint.disclaimer_title')}</h2>
            <p>{t('imprint.disclaimer_1')}</p>
            <p>{t('imprint.disclaimer_2')}</p>

            <h2>{t('imprint.token_title')}</h2>
            <p>{t('imprint.token_text')}{' '}
              <a href="https://lspa-token.info" target="_blank" rel="noopener noreferrer">lspa-token.info</a>.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
